module.exports = __webpack_public_path__ + "img/logo_carre.072888c2.svg";